import React from "react";

const ProtectedRoute = ({ children, isAuthenticated }) => {
  // Since we're now handling authentication at the router level,
  // this component just renders the children if we get here
  // (which means the user is authenticated)
  return children;
};

export default ProtectedRoute;
